export const GUIDE_TOP_RATED_ADVISERS='top-rated-advisers';
export const FIVE_MINUTES = 5 * 60 * 1000
export const DEFAULT_DATEFORMAT = 'yyyy-MM-dd'

const { VITE_QUERY_STALE_TIME } = import.meta.env

export const DEFAULT_QUERY_OPTIONS = {
  staleTime: VITE_QUERY_STALE_TIME ? Number(VITE_QUERY_STALE_TIME) : FIVE_MINUTES,
  refetchOnWindowFocus: false
} as const

export const authenticationPaths = ['%2F', '/', '%2Flogin', '/login', '%2Ftwo-factor', '/two-factor']
export const DATA_TABLE_RECORD_FETCH_LIMIT= 30000;

export const TERMS_AND_CONDITIONS_URL = `${import.meta.env.VITE_CONSUMER_URL}/terms-and-conditions`

export const CONTACT = {
  EMAIL: 'customer_service@vouchedfor.co.uk',
  PHONE_NUMBER: '0203 111 0580',
  ACCOUNTS_TEAM_NUMBER: '0203 111 0583',
};

export const MONTHS = {
  1: "Jan",
  2: "Feb",
  3: "Mar",
  4: "Apr",
  5: "May",
  6: "Jun",
  7: "Jul",
  8: "Aug",
  9: "Sep",
  10: "Oct",
  11: "Nov",
  12: "Dec",
}
export const QUARTERS = {
  1: [1,2,3],
  2: [4,5,6],
  3: [7,8,9],
  4: [10,11,12],
}